import React from 'react';
import { motion } from 'framer-motion';
type Direction = 'up' | 'down' | 'left' | 'right' | 'none';
interface FadeInProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  direction?: Direction;
  distance?: number;
}
const offsets: Record<Direction, {
  x: number;
  y: number;
}> = {
  up: {
    x: 0,
    y: 1
  },
  down: {
    x: 0,
    y: -1
  },
  left: {
    x: 1,
    y: 0
  },
  right: {
    x: -1,
    y: 0
  },
  none: {
    x: 0,
    y: 0
  }
};

/**
 * Entrada al hacer scroll. Solo anima opacidad y transform (compuesto por GPU)
 * para mantener el scroll fluido.
 */
export function FadeIn({
  children,
  className,
  delay = 0,
  direction = 'up',
  distance = 28
}: FadeInProps) {
  const offset = offsets[direction];
  return <motion.div className={className} initial={{
    opacity: 0,
    x: offset.x * distance,
    y: offset.y * distance
  }} whileInView={{
    opacity: 1,
    x: 0,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.15
  }} transition={{
    duration: 0.55,
    ease: [0.16, 1, 0.3, 1],
    delay
  }} data-id="element-33" data-mp="3s10k4tysmmo0">
      {children}
    </motion.div>;
}